import cx from 'classnames';
import OrganicSectionShape from 'themes/organic/assets/organic_section_shape.svg';
import { TexturedCircle } from 'themes/organic/components';

import { ContentContainer } from '../../ContentContainer';
import { Subtitle } from '../../Subtitle/Subtitle';

import s from './ContainedSection.module.css';

type TProps = {
  id: string;
  title?: string;
  className?: string;
  shapeClassName?: string;
  contentClassName?: string;
  children: React.ReactNode;
  showCircle?: boolean;
};

export const ContainedSection = ({
  id,
  title,
  children,
  className,
  shapeClassName,
  contentClassName,
  showCircle = true,
}: TProps) => (
  <section id={id} className={cx(s.root, className)}>
    <div className={cx(s.sectionShapeContainer, shapeClassName)}>
      <OrganicSectionShape />
    </div>

    <Subtitle>{title}</Subtitle>
    <ContentContainer>
      {showCircle && <TexturedCircle className={s.texturedCircle} />}
    </ContentContainer>
    <ContentContainer className={cx(s.content, contentClassName)}>
      {children}
    </ContentContainer>
  </section>
);
